import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class BricksError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('BricksError', ...args);
    }
}
export default BricksError;
